<template>
  <b-input-group>
    <div 
      class="custom-file" 
      style="z-index:10;"
    >
      <input 
        id="customFile" 
        type="file" 
        class="custom-file-input" 
        @change="onFileChanged"
      >
      <label
        class="custom-file-label"
        for="customFile"
      >{{ selectedFile != null ? selectedFile.name : ( public_id || 'Kies bestand' ) }}</label>
    </div>

    <b-input-group-append>
      <b-btn
        :disabled="!selectedFile"
        :variant="!selectedFile ? 'secondary' : 'primary'"
        style="z-index:100;"
        @click="onUpload"
      >
        <b-spinner 
          v-if="progress > -1" 
          :small="true" 
          size="sm" 
          role="status"
        />
        {{ progress > -1 ? 'Uploading...' : 'Uploaden' }}
      </b-btn>
    </b-input-group-append>
  </b-input-group>
</template>

<script>
import axios from "axios";

export default {
  name: "UploadFile",
  props: ["cloud", "preset", "folder", "public_id"],
  data() {
    return {
      selectedFile: null,
      progress: -1
    };
  },
  methods: {
    onFileChanged(event) {
      this.selectedFile = event.target.files[0];
      console.log(this.selectedFile);
    },
    onUpload() {
      var formdata = new FormData();
      formdata.append("upload_preset", this.preset);
      formdata.append("file", this.selectedFile);
      formdata.append("folder", this.folder);
      if (this.public_id) formdata.append("public_id", this.public_id);
      formdata.append("api_key", "991689989472845");
      console.log(formdata);
      this.progress = 1;

      var opts = {
        transformRequest: function(formdata) {
          return formdata;
        },
        onUploadProgress: progressEvent => {
          console.log(progressEvent.loaded / progressEvent.total);
          vm.progress = progressEvent.loaded / progressEvent.total;
        },
        headers: { "X-Requested-With": "XMLHttpRequest" }
      };
      var url = `https://api.cloudinary.com/v1_1/${this.cloud}/image/upload`;
      console.log(url);
      var vm = this;
      axios
        .post(url, formdata, opts)
        .then(function(response) {
          vm.$emit("file-uploaded", response.data);
          vm.progress = -1;
          vm.selectedFile = null;
          console.log("bestand geupload", response.data);
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>
